export default __webpack_public_path__ + "static/media/pink-trashcan.5c0f1704.svg";